import React, { useEffect, useRef } from 'react';
import { ResponsiveImage } from '../../components';
import css from './ListingPage.module.css';

const ListingImgSwiper = props => {
  const { allImages } = props;
  const swiperRef = useRef(null);

  useEffect(() => {
    if (!allImages || allImages.length === 0) return;

    setTimeout(function() {
      const swiperEl = document.querySelector('.listingImg-swiper-container');
      if (!swiperEl) return;

      const counter = document.querySelector('.custom-slide-counter');

      const swiperInstance = new Swiper('.listingImg-swiper-container', {
        loop: true,
        slidesPerView: 1,
        pagination: {
          // Only pass el if the pagination element actually exists in the DOM
          el: swiperEl.querySelector('.swiper-pagination') || null,
          clickable: true,
        },
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
        },
        on: {
          init: function () {
            if (!counter) return; // guard: counter only exists when images > 1
            const totalSlides = this.slides.length;
            const currentIndex = this.realIndex + 1;
            counter.textContent = `${currentIndex}/${totalSlides}`;
          },
          slideChange: function () {
            if (!counter) return; // guard: counter only exists when images > 1
            const totalSlides = this.slides.length;
            const currentIndex = this.realIndex + 1;
            counter.textContent = `${currentIndex}/${totalSlides}`;
          }
        }
      });

      // Manually trigger init event to populate counter on first load
      swiperInstance.emit('init');
    }, 500);
  }, [allImages]);

  if (!allImages || allImages.length === 0) return null;

  return (
    <div className="listingImg-swiper-container" data="listingImg-swiper-container">
      <div className="swiper-wrapper" data="listingImg-swiper">
        {allImages.map((images, index) => (
          <div className="swiper-slide" key={index} data="img-swiper-slide">
            <ResponsiveImage
              rootClassName={css.rootForImage}
              alt={`Image ${index + 1}`}
              image={images}
              variants={Object.keys(images?.attributes?.variants).filter(k => k.startsWith('scaled'))}
            />
          </div>
        ))}
      </div>

      {/* pagination dots */}
      <div className="swiper-pagination" data="data-pagination"></div>

      {/* slide counter — only rendered when there is more than 1 image */}
      {allImages.length > 1 &&
        <div className="custom-slide-counter">1/<span className="totalCount">0</span></div>
      }
    </div>
  );
};

export default ListingImgSwiper;